module.exports = __webpack_public_path__ + "static/media/deny.1fe50072.svg";